module.exports = __webpack_public_path__ + "img/eyein-partner-lenovo.a4fe6bd3.png";